// Bilingual content + static portfolio data for Ali Salem Abdullah Inkis

export const PORTRAIT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_c6302fe2-891f-4b85-b0da-098866e8afbe/artifacts/egbb4w5i_52%20copy%202.webp";

export const PROJECT_IMAGES = {
  kafd: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?q=80&w=1200",
  jazan_refinery: "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?q=80&w=1200",
  jazan_city: "https://images.unsplash.com/photo-1623173651777-e013ac17e563?q=80&w=1200",
  igcc: "https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=1200",
};

export const CONTACT = {
  email: "a.ankis@hotmail.com",
  phone: "+966 554552628",
  linkedin: "https://linkedin.com/in/ali-inkis/",
  location_en: "Saudi Arabia",
  location_ar: "المملكة العربية السعودية",
};

export const t = {
  en: {
    dir: "ltr",
    loading: "Ali Salem Inkis",
    nav: {
      about: "About",
      experience: "Experience",
      impact: "Impact",
      projects: "Projects",
      certifications: "Certifications",
      contact: "Contact",
      langLabel: "AR",
    },
    hero: {
      eyebrow: "Program Manager · Engineering Leadership",
      name1: "Ali Salem",
      name2: "Abdullah Inkis",
      tagline:
        "Driving operational excellence and strategic delivery across Saudi Arabia's most critical infrastructure and megaprojects.",
      sub: "Bridging boardroom strategy with on-the-ground engineering reality.",
      cta1: "Get in touch",
      cta2: "View experience",
      scroll: "Scroll",
    },
    manifesto: {
      eyebrow: "The Approach",
      chapters: [
        {
          n: "01",
          title: "Strategy meets execution",
          body: "Every megaproject lives or dies at the intersection of vision and delivery. I translate boardroom ambition into disciplined, on-the-ground engineering outcomes.",
        },
        {
          n: "02",
          title: "Governance at scale",
          body: "Managing 15+ concurrent projects worth over SAR 200M demands relentless risk management, transparent stakeholder communication, and precise multi-project governance.",
        },
        {
          n: "03",
          title: "Excellence, measured",
          body: "From 94% SLA attainment to projects delivered four months early — I lead with metrics that matter and standards that hold under Aramco-grade scrutiny.",
        },
      ],
    },
    experience: {
      eyebrow: "Career",
      title: "A decade shaping national infrastructure",
      items: [
        {
          role: "Program Manager",
          company: "Tatweer Building Company",
          period: "Aug 2024 — Present",
          desc: "Overseeing strategic portfolios, risk management and multi-project governance across 15+ concurrent projects valued over SAR 200M in operations, maintenance and facility enhancements.",
        },
        {
          role: "Utilities Engineer Specialist & Acting Director",
          company: "Royal Commission for Jubail & Yanbu",
          period: "Dec 2022 — Aug 2024",
          desc: "Managed a SAR 35M annual budget, 100+ critical assets and a 40-person team. Led 50+ facility improvement initiatives, raising standards by 30% and cutting utility interruptions by 15%.",
        },
        {
          role: "Project Manager",
          company: "King Abdullah Financial District (KAFD)",
          period: "Oct 2021 — Nov 2022",
          desc: "Delivered a SAR 64M MEP infrastructure project four months ahead of schedule — earning a formal Letter of Recommendation.",
        },
        {
          role: "QA/QC Electrical Inspection Engineer",
          company: "Applus Velosi / AlFalak — Saudi Aramco Projects",
          period: "2017 — 2021",
          desc: "Enforced strict Aramco quality requirements, managed 400+ non-conformities via QMIS, and led high-stakes witness inspections for LV/MV cable installations.",
        },
        {
          role: "Electrical Engineer",
          company: "Fawaz Abdulaziz Al Hokair",
          period: "2015 — 2017",
          desc: "Supervised site engineering operations and ensured full compliance with safety standards.",
        },
      ],
    },
    impact: {
      eyebrow: "By the numbers",
      title: "Impact that scales",
      stats: [
        { value: 200, prefix: "SAR ", suffix: "M+", label: "Portfolio value managed" },
        { value: 4, prefix: "", suffix: " mo", label: "SAR 64M project delivered early" },
        { value: 94, prefix: "", suffix: "%", label: "SLA attainment in operations" },
        { value: 400, prefix: "SAR ", suffix: "K+", label: "Direct cost savings realised" },
      ],
      recognition: "Recognised by Saudi Aramco (JAPID) as one of the Best Performing Electrical Inspectors, 2018.",
    },
    projects: {
      eyebrow: "Selected Work",
      title: "Landmark projects",
      items: [
        { id: "kafd", name: "King Abdullah Financial District", tag: "SAR 64M · MEP Infrastructure", image: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?q=80&w=1200" },
        { id: "jazan_refinery", name: "Jazan Refinery", tag: "Downstream · Aramco", image: "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?q=80&w=1200" },
        { id: "jazan_city", name: "Jazan City for Primary & Downstream Industries", tag: "Industrial City", image: "https://images.unsplash.com/photo-1623173651777-e013ac17e563?q=80&w=1200" },
        { id: "igcc", name: "Jazan IGCC Power Generation Block", tag: "Power Generation", image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=1200" },
      ],
    },
    skills: {
      eyebrow: "Capabilities",
      title: "What I bring to the table",
      groups: [
        {
          name: "Management",
          items: ["Program & Project Management", "Strategic Planning", "Budget & Contract Management", "Stakeholder Negotiation", "Resource & Vendor Management", "Cross-functional Leadership"],
        },
        {
          name: "Technical",
          items: ["Electrical Engineering", "MEP Projects", "Infrastructure Development", "SATIP & Surveillance", "LV/MV Cable Installations", "RFI/NCR Management"],
        },
        {
          name: "Tools",
          items: ["Primavera P6", "Microsoft Project", "QMIS", "Advanced MS Office", "Technical Reporting", "Performance Analysis"],
        },
      ],
    },
    marquee: "DRIVING OPERATIONAL EXCELLENCE · STRATEGIC DELIVERY · ENGINEERING LEADERSHIP · ",
    certifications: {
      eyebrow: "Credentials",
      title: "Certifications",
      subtitle: "Verified professional certifications and continuous learning.",
      adminBtn: "Owner access",
      uploadBtn: "Upload certification",
      logout: "Sign out",
      empty: "No certifications yet.",
      viewFile: "View file",
    },
    contact: {
      eyebrow: "Let's talk",
      title: "Start a conversation",
      subtitle: "Open to program leadership, advisory and strategic delivery roles across the Kingdom.",
      name: "Your name",
      email: "Email address",
      subject: "Subject",
      message: "Your message",
      send: "Send message",
      sending: "Sending…",
      success: "Message sent. Thank you — I'll be in touch.",
      error: "Something went wrong. Please try again.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      locationLabel: "Location",
      linkedinLabel: "LinkedIn",
    },
    footer: {
      rights: "All rights reserved.",
      built: "Executive portfolio",
    },
    admin: {
      title: "Owner sign in",
      desc: "Only the site owner can manage certifications.",
      email: "Email",
      password: "Password",
      signin: "Sign in",
      signingin: "Signing in…",
      failed: "Invalid credentials.",
      uploadTitle: "Upload certification",
      titleEn: "Title (English)",
      titleAr: "Title (Arabic)",
      issuerEn: "Issuer (English)",
      issuerAr: "Issuer (Arabic)",
      year: "Year",
      file: "Certificate file (image or PDF)",
      save: "Save certification",
      saving: "Saving…",
      delete: "Delete",
    },
  },
  ar: {
    dir: "rtl",
    loading: "علي سالم إنكِس",
    nav: {
      about: "نبذة",
      experience: "الخبرة",
      impact: "الأثر",
      projects: "المشاريع",
      certifications: "الشهادات",
      contact: "تواصل",
      langLabel: "EN",
    },
    hero: {
      eyebrow: "مدير برامج · قيادة هندسية",
      name1: "علي سالم",
      name2: "عبدالله إنكِس",
      tagline:
        "قيادة التميّز التشغيلي والتسليم الاستراتيجي عبر أهم مشاريع البنية التحتية والمشاريع الكبرى في المملكة العربية السعودية.",
      sub: "أربط بين الاستراتيجية على مستوى القيادة والواقع الهندسي في الميدان.",
      cta1: "تواصل معي",
      cta2: "استعرض الخبرة",
      scroll: "مرّر",
    },
    manifesto: {
      eyebrow: "المنهجية",
      chapters: [
        {
          n: "٠١",
          title: "الاستراتيجية تلتقي بالتنفيذ",
          body: "كل مشروع كبير يتحدد مصيره عند تقاطع الرؤية مع التنفيذ. أُترجم طموح القيادة إلى نتائج هندسية منضبطة على أرض الواقع.",
        },
        {
          n: "٠٢",
          title: "الحوكمة على نطاق واسع",
          body: "إدارة أكثر من ١٥ مشروعاً متزامناً بقيمة تتجاوز ٢٠٠ مليون ريال تتطلب إدارة صارمة للمخاطر وتواصلاً شفافاً مع أصحاب المصلحة وحوكمة دقيقة.",
        },
        {
          n: "٠٣",
          title: "تميّز قابل للقياس",
          body: "من تحقيق ٩٤٪ في اتفاقيات مستوى الخدمة إلى تسليم مشاريع قبل موعدها بأربعة أشهر — أقود بمعايير تصمد أمام تدقيق أرامكو.",
        },
      ],
    },
    experience: {
      eyebrow: "المسيرة",
      title: "عقد من تشكيل البنية التحتية الوطنية",
      items: [
        {
          role: "مدير برامج",
          company: "شركة تطوير للمباني",
          period: "أغسطس ٢٠٢٤ — حتى الآن",
          desc: "الإشراف على المحافظ الاستراتيجية وإدارة المخاطر وحوكمة المشاريع المتعددة عبر أكثر من ١٥ مشروعاً متزامناً بقيمة تتجاوز ٢٠٠ مليون ريال في التشغيل والصيانة وتحسين المرافق.",
        },
        {
          role: "أخصائي مهندس مرافق ومدير بالإنابة",
          company: "الهيئة الملكية بالجبيل وينبع",
          period: "ديسمبر ٢٠٢٢ — أغسطس ٢٠٢٤",
          desc: "إدارة ميزانية سنوية بقيمة ٣٥ مليون ريال وأكثر من ١٠٠ أصل حيوي وفريق من ٤٠ فرداً. قيادة أكثر من ٥٠ مبادرة لتحسين المرافق ورفع المعايير بنسبة ٣٠٪ وخفض انقطاعات الخدمات بنسبة ١٥٪.",
        },
        {
          role: "مدير مشروع",
          company: "مركز الملك عبدالله المالي (كافد)",
          period: "أكتوبر ٢٠٢١ — نوفمبر ٢٠٢٢",
          desc: "تسليم مشروع بنية تحتية ميكانيكية وكهربائية وسباكة بقيمة ٦٤ مليون ريال قبل موعده بأربعة أشهر — بخطاب شكر رسمي.",
        },
        {
          role: "مهندس فحص وضبط جودة كهربائي",
          company: "أبلس فيلوسي / الفلك — مشاريع أرامكو",
          period: "٢٠١٧ — ٢٠٢١",
          desc: "تطبيق متطلبات الجودة الصارمة لأرامكو وإدارة أكثر من ٤٠٠ حالة عدم مطابقة عبر نظام QMIS وقيادة عمليات فحص حرجة لتمديدات الكابلات ذات الجهد المنخفض والمتوسط.",
        },
        {
          role: "مهندس كهربائي",
          company: "فواز عبدالعزيز الحكير",
          period: "٢٠١٥ — ٢٠١٧",
          desc: "الإشراف على العمليات الهندسية في الموقع وضمان الالتزام الكامل بمعايير السلامة.",
        },
      ],
    },
    impact: {
      eyebrow: "بالأرقام",
      title: "أثر يتوسّع",
      stats: [
        { value: 200, prefix: "", suffix: "م+ ريال", label: "قيمة المحفظة المُدارة" },
        { value: 4, prefix: "", suffix: " أشهر", label: "تسليم مشروع ٦٤م ريال مبكراً" },
        { value: 94, prefix: "", suffix: "٪", label: "تحقيق اتفاقيات مستوى الخدمة" },
        { value: 400, prefix: "", suffix: "ألف+ ريال", label: "وفورات مباشرة في التكاليف" },
      ],
      recognition: "تكريم من أرامكو السعودية (JAPID) كأحد أفضل مهندسي الفحص الكهربائي أداءً لعام ٢٠١٨.",
    },
    projects: {
      eyebrow: "أعمال مختارة",
      title: "مشاريع بارزة",
      items: [
        { id: "kafd", name: "مركز الملك عبدالله المالي", tag: "٦٤م ريال · بنية تحتية MEP", image: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?q=80&w=1200" },
        { id: "jazan_refinery", name: "مصفاة جازان", tag: "التكرير · أرامكو", image: "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?q=80&w=1200" },
        { id: "jazan_city", name: "مدينة جازان للصناعات الأساسية والتحويلية", tag: "مدينة صناعية", image: "https://images.unsplash.com/photo-1623173651777-e013ac17e563?q=80&w=1200" },
        { id: "igcc", name: "مجمع توليد الطاقة IGCC بجازان", tag: "توليد الطاقة", image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?q=80&w=1200" },
      ],
    },
    skills: {
      eyebrow: "القدرات",
      title: "ما أقدّمه",
      groups: [
        {
          name: "الإدارة",
          items: ["إدارة البرامج والمشاريع", "التخطيط الاستراتيجي", "إدارة الميزانيات والعقود", "التفاوض مع أصحاب المصلحة", "إدارة الموارد والموردين", "القيادة متعددة الوظائف"],
        },
        {
          name: "التقنية",
          items: ["الهندسة الكهربائية", "مشاريع MEP", "تطوير البنية التحتية", "SATIP والمراقبة", "تمديدات الكابلات LV/MV", "إدارة RFI/NCR"],
        },
        {
          name: "الأدوات",
          items: ["Primavera P6", "Microsoft Project", "QMIS", "أوفيس المتقدم", "التقارير الفنية", "تحليل الأداء"],
        },
      ],
    },
    marquee: "قيادة التميّز التشغيلي · التسليم الاستراتيجي · القيادة الهندسية · ",
    certifications: {
      eyebrow: "المؤهلات",
      title: "الشهادات",
      subtitle: "شهادات مهنية موثّقة وتعلّم مستمر.",
      adminBtn: "دخول المالك",
      uploadBtn: "رفع شهادة",
      logout: "تسجيل الخروج",
      empty: "لا توجد شهادات بعد.",
      viewFile: "عرض الملف",
    },
    contact: {
      eyebrow: "لنتحدث",
      title: "لنبدأ محادثة",
      subtitle: "منفتح على أدوار قيادة البرامج والاستشارات والتسليم الاستراتيجي في أنحاء المملكة.",
      name: "الاسم",
      email: "البريد الإلكتروني",
      subject: "الموضوع",
      message: "رسالتك",
      send: "إرسال الرسالة",
      sending: "جارٍ الإرسال…",
      success: "تم إرسال الرسالة. شكراً لك — سأتواصل معك قريباً.",
      error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      emailLabel: "البريد",
      phoneLabel: "الهاتف",
      locationLabel: "الموقع",
      linkedinLabel: "لينكدإن",
    },
    footer: {
      rights: "جميع الحقوق محفوظة.",
      built: "ملف تعريف تنفيذي",
    },
    admin: {
      title: "تسجيل دخول المالك",
      desc: "المالك فقط يمكنه إدارة الشهادات.",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      signin: "تسجيل الدخول",
      signingin: "جارٍ الدخول…",
      failed: "بيانات غير صحيحة.",
      uploadTitle: "رفع شهادة",
      titleEn: "العنوان (إنجليزي)",
      titleAr: "العنوان (عربي)",
      issuerEn: "الجهة (إنجليزي)",
      issuerAr: "الجهة (عربي)",
      year: "السنة",
      file: "ملف الشهادة (صورة أو PDF)",
      save: "حفظ الشهادة",
      saving: "جارٍ الحفظ…",
      delete: "حذف",
    },
  },
};

// ---------------------------------------------------------------------------
// Editor defaults (owner CMS)
// ---------------------------------------------------------------------------
export const THEME_DEFAULT = {
  accent: "#C5A059",
  accentBright: "#D4AF37",
  ink: "#131313",
  inkSoft: "#5C5C5C",
  bg: "#FAF9F6",
  sand: "#F0EFEA",
  ivory: "#FFFFFF",
  textScale: 1,
};

export const THEME_PRESETS = [
  { name: "Champagne", accent: "#C5A059", accentBright: "#D4AF37", ink: "#131313", bg: "#FAF9F6", sand: "#F0EFEA" },
  { name: "Emerald", accent: "#1F7A5A", accentBright: "#2FA576", ink: "#0E1A16", bg: "#F6FAF8", sand: "#E9F1EC" },
  { name: "Sapphire", accent: "#2B6CB0", accentBright: "#3A86D6", ink: "#0F1A2B", bg: "#F6F8FB", sand: "#E9EEF5" },
  { name: "Terracotta", accent: "#C0603F", accentBright: "#DD7A54", ink: "#211410", bg: "#FBF7F4", sand: "#F1E8E1" },
  { name: "Graphite", accent: "#111111", accentBright: "#444444", ink: "#0A0A0A", bg: "#F7F7F5", sand: "#ECECEA" },
];

export const SECTION_KEYS = [
  "manifesto",
  "experience",
  "impact",
  "projects",
  "skills",
  "marquee",
  "certifications",
  "contact",
];

export const EDITOR = {
  en: {
    ownerAccess: "Owner access",
    editing: "Editing",
    edit: "Edit content",
    preview: "Preview",
    save: "Save changes",
    saving: "Saving…",
    saved: "All changes saved",
    design: "Design",
    sections: "Sections",
    reset: "Reset to defaults",
    resetConfirm: "Reset all content and design to defaults? This cannot be undone.",
    logout: "Sign out",
    accent: "Accent color",
    inkColor: "Text color",
    bgColor: "Background",
    textSize: "Text size",
    presets: "Palettes",
    addItem: "Add",
    sectionNames: {
      manifesto: "Approach",
      experience: "Experience",
      impact: "Impact",
      projects: "Projects",
      skills: "Skills",
      marquee: "Marquee",
      certifications: "Certifications",
      contact: "Contact",
    },
    hint: "Click any text to edit it. Use the controls to add, delete, or reorder.",
    imageUrl: "Image URL",
  },
  ar: {
    ownerAccess: "دخول المالك",
    editing: "وضع التحرير",
    edit: "تحرير المحتوى",
    preview: "معاينة",
    save: "حفظ التغييرات",
    saving: "جارٍ الحفظ…",
    saved: "تم حفظ جميع التغييرات",
    design: "التصميم",
    sections: "الأقسام",
    reset: "استعادة الإعدادات الافتراضية",
    resetConfirm: "استعادة كل المحتوى والتصميم إلى الوضع الافتراضي؟ لا يمكن التراجع.",
    logout: "تسجيل الخروج",
    accent: "لون التمييز",
    inkColor: "لون النص",
    bgColor: "الخلفية",
    textSize: "حجم النص",
    presets: "الألوان",
    addItem: "إضافة",
    sectionNames: {
      manifesto: "المنهجية",
      experience: "الخبرة",
      impact: "الأثر",
      projects: "المشاريع",
      skills: "المهارات",
      marquee: "الشريط",
      certifications: "الشهادات",
      contact: "تواصل",
    },
    hint: "انقر على أي نص لتحريره. استخدم الأدوات للإضافة أو الحذف أو إعادة الترتيب.",
    imageUrl: "رابط الصورة",
  },
};

// Templates for adding new list items (bilingual, parallel)
export const TEMPLATES = {
  manifestoChapter: {
    en: { n: "00", title: "New chapter", body: "Describe this principle." },
    ar: { n: "٠٠", title: "فصل جديد", body: "صف هذا المبدأ." },
  },
  experienceItem: {
    en: { role: "New role", company: "Company", period: "Year — Year", desc: "Describe your impact." },
    ar: { role: "دور جديد", company: "الشركة", period: "سنة — سنة", desc: "صف أثرك." },
  },
  impactStat: {
    en: { value: 100, prefix: "", suffix: "+", label: "New metric" },
    ar: { value: 100, prefix: "", suffix: "+", label: "مؤشر جديد" },
  },
  projectItem: {
    en: { id: "new", name: "New project", tag: "Category", image: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?q=80&w=1200" },
    ar: { id: "new", name: "مشروع جديد", tag: "الفئة", image: "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?q=80&w=1200" },
  },
  skillGroup: {
    en: { name: "New group", items: ["Skill"] },
    ar: { name: "مجموعة جديدة", items: ["مهارة"] },
  },
  skillItem: { en: "New skill", ar: "مهارة جديدة" },
};
